const DisplayOptions = (props) => {

    const {
        roomsFound = 'N/A',
        roomLevel = 'N/A',
        toggleGridView = () => {},
        onRefine = () => {},
        hideRefine = false,
        isGrid
    } = props;

    const onGridView = (event) => {

        //  console.log('onGrid');

        event.preventDefault();

        props.toggleGridView(true);
    };

    const onListView = (event) => {

        event.preventDefault();

        //  console.log('onList');

        props.toggleGridView(false);
    };

    return (
        <div>
            <div className="list-grid-viewer-about">
                About accommodation Levels
                <a href="#levels" className="js-magnific-popup"><i className="ic ic-info" /></a>
            </div>

            <div className="section-title-wrapper row">
                <div className="section-title col-xs-9">
                    { roomsFound } rooms found <span>{ roomLevel }</span>
                </div>

                <div className="section-switcher col-xs-3">
                    <a className={`icon-grid js-disable-list hidden-xs ${ isGrid ? 'active' : ''}`} href="#"  onClick={onGridView}>
                        <span className="ic ic-grid-view" />
                        <span className="icon-title">Grid View</span>
                    </a>
                    <a className={`icon-list js-enable-list hidden-xs ${ isGrid ? '' : 'active'}`} href="#" onClick={onListView}>
                        <span className="ic ic-list-view" />
                        <span className="icon-title">List View</span>
                    </a>
                    {
                        !hideRefine &&
                        <a className="icon-refine js-show-filter visible-xs-inline-block" href="#">
                            <span className="ic ic-refine" />
                            <span className="icon-title" onClick={props.onRefine}>Refine</span>
                        </a>
                    }
                </div>
            </div>
        </div>
    );
};

export default DisplayOptions;
